<template>
  <article class="text-white bg-gray-900 w-full border border-gray-700">
    <header class="flex items-center justify-between p-2 border-b border-gray-700 shadow">
      <slot name="header" />
      <FontAwesomeIcon
        class="cursor-pointer transition-transform duration-300 ease-in-out"
        :class="state.expanded ? 'rotate-180' : 'rotate-0'"
        :icon="'chevron-up'"
        @click="togglePanelVisibility"
      />
    </header>

    <section class="collapsible-container" :class="{ expanded: state.expanded }">
      <div class="overflow-hidden">
        <slot />
      </div>
    </section>
  </article>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'

type State = {
  expanded: boolean
}

const state = reactive<State>({
  expanded: false,
})

function togglePanelVisibility() {
  state.expanded = !state.expanded
}
</script>

<style scoped>
.collapsible-container {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 500ms;
}

.collapsible-container.expanded {
  grid-template-rows: 1fr;
}
</style>
